import { Capacitor } from '@capacitor/core'

const platform = Capacitor.getPlatform();
const isAndroid = platform === 'android';
const isIOS = platform === 'ios';
const domain = import.meta.env.VITE_REMOTE_DOMAIN;

export const environment = {
  API_CLIENT:
    isAndroid || isIOS
      ? `${domain}/bet-share/composer`
      : '/bet-share/composer',

  API_CONDUCTOR:
    isAndroid || isIOS
      ? `${domain}/bet-share/composer-ws`
      : '/bet-share/composer-ws',

  API_ODDS:
    isAndroid || isIOS
      ? `${domain}/odds`
      : '/odds',
};